module.exports = __webpack_public_path__ + "img/35_30.923c3e4a.png";